import React, { useState, useImperativeHandle, useContext, useRef, useEffect } from 'react';
import TContext from '../../context'
import Animate from '../../../animate'
import * as THREE from 'three';
import http from '../../../../lib/http'
import * as apis from '../../../../lib/apis'
import { ColorPicker } from 'antd';

interface Props {
    action?: any
}

export interface Action {
    setShow?: (isShow: boolean) => void;
    confirm?: () => boolean;
    cancel?: () => void;
}

const groupHeight = 40
export const Height = groupHeight

var previewColorObject: any = null

const Index = (props: Props) => {
    const [show, setInnerShow] = useState(false)
    const tc = useContext(TContext)

    const [selectedColor, setSelectedColor] = useState<string | null>(null);
    const [originalColor, setOriginalColor] = useState<string | null>(null);
    const [colorPalette, setColorPalette] = useState<string[]>([]);
    useImperativeHandle(props.action, () => ({
        setShow,
        confirm,
        cancel
    }));



    useEffect(() => {
        http.get(apis.DESIGNER_COLOR).then((res: any) => {
            const response = res as any;
            const colors = response.list
            setColorPalette(colors);

        }).catch((error) => {
            console.error('获取颜色列表失败:', error);
        });
    }, []);
    const setShow = async (isShow: boolean) => {
        previewColorObject = null
        setInnerShow(isShow)
    }

    // //取消
    const cancel = () => {
        if (originalColor && tc.threeClient && tc.threeClient.scene && tc.curCutpartCode) {
            const threeColor = new THREE.Color(originalColor);
            tc.threeClient.scene.traverse((child: any) => {
                if (child.isMesh && child.material && child.name &&
                    child.name.includes(tc.curCutpartCode) && child.material.color) {
                    child.material.color = threeColor;
                    child.material.needsUpdate = true;
                }
            });
        }

        setInnerShow(false)

    }

    //确认
    const confirm = () => {
        setInnerShow(false)
        setOriginalColor(null); // 重置
        return true;
    }

    const handleColorSelect = (color: string) => {
        setSelectedColor(color);
        if (tc.curCanvasClient && tc.curCutpartCode) {
            try {
                // 应用颜色到Fabric.js对象
                applyColorToFabricObject(tc.curCanvasClient, color, tc.curCutpartCode);
            } catch (error) {
                console.error('修改颜色时出错:', error);
            }
        }

    };

    const applyColorToFabricObject = (canvasClient: any, color: string, cutpartCode: string) => {
        const canvas = canvasClient.getFabricCanvas();
        const rgbaColor = normalizeToRgba(color, 0); // 30%透明度
        canvas.set('backgroundColor', rgbaColor);
        canvas.renderAll();

        // 修改设计材质的颜色
        tc.threeClient.scene.traverse((child: any) => {
            if (child.isMesh && child.material) {
                if (child?.material) {

                    if (child?.material?.name === cutpartCode) {
                        // 优先按材质名称匹配（影响所有共享材质的网格）
                        child.material.color = new THREE.Color(color);
                    } else if (child?.material?.name === "" && child?.name === cutpartCode) {
                        // 网格名称匹配
                        child.material.color = new THREE.Color(color);
                    }
                }
            }
        });

        // 标记为已更改
        tc?.markAsChanged?.();
    };
    // 统一颜色处理函数
    function normalizeToRgba(color: string, alpha: number): string {
        // 十六进制格式
        if (color.startsWith('#')) {
            return hexToRgba(color, alpha);
        }
        // rgb 格式（没有透明度）
        if (color.startsWith('rgb(')) {
            return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
        }

        // rgba 格式（已有透明度）
        if (color.startsWith('rgba(')) {
            // 替换现有的透明度
            return color.replace(/rgba\(([^,]+),([^,]+),([^,]+),([^)]+)\)/, `rgba($1, $2, $3, ${alpha})`);
        }

        // 默认返回黑色
        console.warn('无法识别的颜色格式，使用默认颜色:', color);
        return `rgba(0, 0, 0, ${alpha})`;
    }

    function hexToRgba(hex: string, alpha: number) {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return (

        <Animate show={show} style={{
            bottom: 0,
            position: "fixed",
            left: 0,
            zIndex: 11,
            width: "100%",
            background: "#FFFFFF",
            paddingBottom: tc.safeHeigth
        }}>
            <div style={{ padding: '16px' }}>

                <ColorPicker
                    value={selectedColor || ''}
                    defaultValue={selectedColor}
                    onChange={(color, cssColor) => {
                        setSelectedColor(cssColor);
                        handleColorSelect(cssColor);
                    }}
                />
            </div>
            <div id="scroll" style={{
                height: tc.fabricW ? tc.fabricW - 30 : 0,
                overflowY: "auto",
                overflowX: "hidden",
                padding: "0 5px"
            }}>

                {/* 颜色网格 */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                }}>
                    {(colorPalette as any).map((category: any, categoryIndex: number) => (
                        <div key={category.id || categoryIndex}>
                            <div style={{
                                fontSize: '16px',
                                fontWeight: 'bold',
                                marginBottom: '12px',
                                color: '#333',
                                padding: '0 8px',
                                borderBottom: '1px solid #ccc'
                            }}>
                            </div>

                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                gap: '16px',
                            }}>
                                {category.colors.map((colorItem: any, colorIndex: number) => (
                                    <div
                                        key={colorItem.id || `${categoryIndex}-${colorIndex}`}
                                        onClick={() => handleColorSelect(colorItem.code)}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            // padding: '8px',
                                            borderRadius: '8px',
                                            backgroundColor: selectedColor === colorItem.code ? '#f0f8ff' : 'transparent',
                                            transition: 'all 0.2s ease',
                                        }}
                                        title={`${colorItem.name} - ${colorItem.code}`}
                                    >
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '35px',
                                                backgroundColor: colorItem.code,
                                                borderRadius: '4px',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                outline: selectedColor === colorItem.code ? '2px solid #1890ff' : 'none',
                                                outlineOffset: selectedColor === colorItem.code ? '-2px' : '0',
                                                marginBottom: '6px',
                                            }}
                                        />
                                        {/* 文字 */}
                                        <div
                                            style={{
                                                fontSize: '12px',
                                                color: '#333',
                                                textAlign: 'center',
                                                lineHeight: '1.2',
                                                fontWeight: selectedColor === colorItem.code ? '500' : '400',
                                                maxWidth: '100%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {colorItem.code}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </Animate>

    )

}

export default Index
